/**
 * GLBLP-1354 — blog → product/collection click tracking (US).
 *
 * Fires a GA4 `blog_cta_click` event when a reader clicks from a blog article
 * through to a product or collection page.
 *
 * Delivery: `window.gtag`. On US the gtag stub is defined in theme.liquid for
 * Cookiebot consent defaults, and the Shopify Google & YouTube channel loads
 * gtag.js for G-W4L4JDFMXJ into the same main-window `dataLayer`. Verified
 * 2026-09-09 against the live storefront: a manual gtag event produced
 * `POST analytics.google.com/g/collect?tid=G-W4L4JDFMXJ` → 204. No GTM tag and
 * no GA4 configuration change is required for collection to begin.
 *
 * Listener is delegated on `document` (one script covers the hero, the article
 * body and the promo section, which are three separate Shopify sections) and
 * runs in the capture phase so a section handler that stops propagation cannot
 * swallow it.
 *
 * Ported from the AU implementation. The AU `product_carousel` position has no
 * US equivalent; the US article page instead carries a `two-column-section`
 * promo block below the article, tracked as `article_promo`.
 */
(function () {
  'use strict';

  function linkType(pathname) {
    if (pathname.indexOf('/products/') !== -1) return 'product';
    if (pathname.indexOf('/collections/') !== -1) return 'collection';
    return null;
  }

  /**
   * Which article surface the link sits in, or null if it is outside the
   * article altogether (header nav, search modal, footer, Rebuy cart drawer).
   * Returning null is what keeps ordinary site navigation out of the numbers —
   * a US article page carries ~53 product/collection links, of which only 2 are
   * genuine article CTAs (measured 2026-09-09), so an unscoped listener would
   * count mega-menu and cart-recommendation clicks as blog CTA clicks.
   */
  function linkPosition(link) {
    if (link.closest('.article-hero')) return 'hero_cta';
    if (link.closest('.article-content')) return 'article_body';
    if (link.closest('.two-column-section')) return 'article_promo';
    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target && event.target.closest && event.target.closest('a[href]');
      if (!link) return;

      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (e) {
        return;
      }

      // Same-origin only — external links are already covered by GA4's
      // built-in outbound click event, so tracking them here would duplicate.
      if (url.hostname !== window.location.hostname) return;

      var type = linkType(url.pathname);
      if (!type) return;

      // Only count links inside the article itself, not site navigation.
      var position = linkPosition(link);
      if (!position) return;

      if (typeof window.gtag !== 'function') return;

      window.gtag('event', 'blog_cta_click', {
        link_url: url.pathname,
        link_text: (link.textContent || '').trim().slice(0, 100),
        link_type: type,
        link_position: position,
        blog_article: window.location.pathname
      });
    },
    true
  );
})();
